/* *************************
 * 	hover actions
 * ************************* */
var hoverActions = {
	init:function(){
	    $('.hover-add-class').mouseenter(function(e) {
	    	var target = $(e.currentTarget);
	    	var css_selector = target.data('hv-selector');
	    	var css_class = target.data('hv-class');
	    	if (typeof(css_selector) == 'undefined' || css_selector == '') css_selector = e.currentTarget;
	    	$(css_selector).addClass(css_class);
	    }).mouseleave(function(e) {
	    	var target = $(e.currentTarget);
	    	var css_selector = target.data('hv-selector');
	    	var css_class = target.data('hv-class');
	    	if (typeof(css_selector) == 'undefined' || css_selector == '') css_selector = e.currentTarget;
	    	$(css_selector).removeClass(css_class);
	    });
	}
};

$(document).ready(function() {
	hoverActions.init();
});

/* *************************
 * 	slick slider functions
 * ************************* */

/*
	slickPagingInfo
	Example:
	<div class="gallerySlider" data-paging=".gallery-paging-info">...</div>
	<div class="gallery-paging-info"></div>
	slickPagingInfo.init('.gallerySlider', ' | ');
 */
window.slickPagingInfo = {
	init:function(selector){
		var $this = this,
			pagingSelector = $(selector).data('paging'),
			divider = $(selector).data('divider'),
			progressSelector = $(selector).data('progress'),
			numlength = $(selector).data('numlength');
		// paging
		if (typeof pagingSelector != 'undefined') {
			if (typeof divider == 'undefined') divider = ' | ';
	        $(selector).on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
	            //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
	            var i = (currentSlide ? currentSlide : 0) + 1;
				var pagingSelector = $(selector).data('paging');
	            $this.set(selector, pagingSelector, i, divider, numlength);
	        });
	        $this.set(selector, pagingSelector, 1, divider, numlength);
		}
		// progress
		if (typeof progressSelector != 'undefined') {
			var $slider = $(selector).first();
			$slider.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {   
	            //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
	            var i = (currentSlide ? currentSlide : 0) + 1;
				var progressSelector = $(selector).data('progress');
				$this.setProgress(selector, progressSelector, i, numlength);
			});
			$this.setProgress(selector, progressSelector, 1, numlength);
		}
	},
	
	set:function(selector, pagingSelector, currentSlide, divider, numlength){
		$(pagingSelector).html(this.pad(currentSlide,numlength) + '<span class="font-h">' + divider + this.pad($(selector).slick('getSlick').slideCount,numlength) + '</span>');
	},
	setProgress:function(selector, progressSelector, currentSlide, numlength){
		var slideCount = $(selector).first().slick('getSlick').slideCount;
		var calc = ( (currentSlide) / (slideCount) ) * 100;
		var $progressBar = $(progressSelector).first();
		$progressBar
	      .css('background-size', calc + '% 2px')
	      .attr('aria-valuenow', calc );
		$progressBar.html('<div class="progressno">' + currentSlide + '</div><div class="progresscount">' + slideCount + '</div>');
	},
	pad:function(num, size) {
		if (typeof size == 'undefined') return num;
	    num = num.toString();
	    while (num.length < size) num = "0" + num;
	    return num;
	}
}

/* *******************
 * Comfortcontact
 * ****************** */
function showComfortcontact(){
	$('.comfortcontact-box').addClass('show-box');
	$('BODY').addClass('comfortcontact-open');
}
function hideComfortcontact(){
	$('.comfortcontact-box').removeClass('show-box');
	$('BODY').removeClass('comfortcontact-open');
}

$(document).ready(function () {
	$( ".btn-comfortcontact" ).hover(
	      function() {
	    	showComfortcontact();
	      },
	      function() {
	      	$(document).on("mouseleave",'.comfortcontact-box, .btn-comfortcontact', function () { 
	      		if($(".comfortcontact-box:hover").length != 0) return;
				hideComfortcontact();
	      		$(document).off('mouseleave', '.comfortcontact-box, .btn-comfortcontact');
			});
	      }
	);
	$( ".btn-comfortcontact" ).click(function() {
		showComfortcontact(this);
		$(document).on("mouseup.hideDocClick", function () { hideComfortcontact();$(document).off('.hideDocClick'); });
	});
});

/* *************************
 * 	nav
 * ************************* */
window.nav = {
	menuContainerId : 'main-menu',
	navbarNavSelector : '#mainnav .navbar-nav',
	dropdown : $("#mainnav .navbar-nav > .dropdown"),
	dropdownDropdown : $("#mainnav .navbar-nav .dropdown .dropdown > .dropdown-item"),
	dropdownToggle : $(".dropdown-toggle"),
	dropdownMenu : $(".dropdown-menu"),
	showClass : "show",
	navMobiledDdClass : '.mobile-dd-toggle',
	navMobileBreakpoint:0,
	init:function(){
		/*
		nav.dropdown.hover(
	      function() {
			if ($(window).width() > nav.navMobileBreakpoint) nav.openHoverMenu(this);
	      },
	      function() {
	  		if ($(window).width() > nav.navMobileBreakpoint) nav.closeHoverMenu();
	      }
	    );
		*/
		/*
	    $(nav.navbarNavSelector + ' .nav-link, ' + nav.navbarNavSelector + ' .dropdown-item').on('click', function() {
	        $('#' + nav.menuContainerId).collapse('hide');
	    });
		*/
		/* mobile-dd-toggle */
		$("#mainnav " + nav.navMobiledDdClass).click(nav.switchMobileDdToggle);
        $("#mainnav " + nav.navMobiledDdClass).keydown(function(e) {
	        if (e.key === "Enter") nav.switchMobileDdToggle(e);
        });
	},
	switchMobileDdToggle:function(e) {
			if ($(e.currentTarget).attr("aria-expanded") == 'false') {
		        nav.openMenu($(e.currentTarget).closest('.dropdown'));
			} else {
		        nav.closeMenu($(e.currentTarget).closest('.dropdown'));
			}
	    	e.stopPropagation();
	        e.preventDefault();
	},
	openMenu:function(e){
		var $this = $(e);
	    $this.addClass(nav.showClass);
	    $this.children(nav.dropdownToggle).attr("aria-expanded", "true");
	    $this.children(nav.dropdownMenu).addClass(nav.showClass);
		$this.children(nav.dropdownToggle).children(nav.navMobiledDdClass).attr("aria-expanded", "true");
	},
	closeMenu:function(e){
		if (e) {
	    	var $this = e;			
		} else {
	    	var $this = $(nav.dropdown);
		}
        $this.removeClass(nav.showClass);
        $this.children(nav.dropdownToggle).attr("aria-expanded", "false");
        $this.children(nav.dropdownMenu).removeClass(nav.showClass);

		$this.find(nav.navMobiledDdClass).first().attr("aria-expanded", "false");
			
	},
	openHoverMenu:function(e){
		nav.closeHoverMenu();
		nav.openMenu(e);
		nav.dropdown.click(
	      function(e) {
                nav.closeHoverMenu();
		});
	},
	closeHoverMenu:function(e){
		nav.closeMenu(nav.dropdown);			
	},
};